<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('detail')"></pageTitle>
        <myDetailCell v-if="labels.length > 0" :info="labels" :title="$t('school.recruit')">
          <template v-slot:salary="{ data }">
            <div class="salary">
              <div class="hkd">{{ "HKD" }}</div>
              <div class="mg-left10">{{ data.value }}</div>
            </div>
          </template>
          <template v-slot:salary_two="{ data }">
            <div class="salary">
              <div class="hkd">{{ "HKD" }}</div>
              <!-- <Input
                                v-model="data.value_two"
                                placeholder="—"
                                type="number"
              />-->
              <div class="mg-left10">{{ data.value_two }}</div>
            </div>
          </template>
        </myDetailCell>

        <Row justify="end" class="mg-top20">
          <Col>
            <Button @click="$base.linkBack()">{{$t("back")}}</Button>
            <!-- <Button type="primary" @click="handleSubmit">{{
                            $t("modify")
            }}</Button>-->
          </Col>
        </Row>
      </div>
    </div>

    <Input class="hide_input" />
  </div>
</template>

<script>
import myDetailCell from "@/components/myDetailCell";
import pageTitle from "@/components/pageTitle";

export default {
  name: "recruit_detail",
  components: {
    myDetailCell,
    pageTitle
  },
  data () {
    return {
      id: this.$base.getRequest().id,
      labels: []
    };
  },
  mounted () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this.$base.showLoading();
      this.$request.sendPost(
        "job/before-upd",
        { job_id: this.id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          let job_type = data.types.filter(
            item => item.key == data.job.job_type
          );
          let tans = ""
          if (data.job.tags.length > 0) {
            data.job.tags.forEach((e, i) => {
              if (i == 0) {
                tans = e.tag_cname
              } else {
                tans += ' ／ ' + e.tag_cname
              }
            });
          }
          this.labels = [
            {
              label: this.$t("school.work_number"),
              value: data.job.job_code
            },
            {
              label: this.$t("school.recruit_type"),
              value: job_type[0].value
            },
            { label: this.$t("school.tag"), value: tans },
            {
              label: this.$t("school.job_title"),
              value: data.job.job_cname
            },
            {
              label: this.$t("school.job_desc"),
              value: data.job.job_cdesc
            },
            {
              label: this.$t("school.require"),
              value: data.job.job_ccontent
            },
            {
              label: this.$t("school.entry_date"),
              value: data.job.applicable == 1 ? this.$t("NotSuitable") : data.job.expiry_date_end == "" ? data.job.entry_date : data.job.entry_date + " ~ " + data.job.expiry_date_end
            },
            {
              label: this.$t("school.work_period"),
              value: data.job.job_period,
              value_two: data.job.job_period_max
            },
            {
              label: this.$t("SalaryType"),
              value: data.job.salary_type_name
            },
            {
              label: this.$t("school.salary_range"),
              value: data.job.salary_range_name
            },
            {
              label: this.$t("school.salary_range2"),
              value: data.job.job_rate,
              slot: "salary",
              value_two: data.job.job_rate_max,
              slot_two: "salary_two"
            },
            {
              label: this.$t("school.post_date"),
              value: data.job.posting_date
            },
            {
              label: this.$t("school.expiry_date"),
              value: data.job.expiry_date
            },
          ];
        }
      );
    },
    handleSubmit () {
      console.log(this.labels);
    }
  }
};
</script>

<style scoped>
.salary {
  padding-left: 8px;
  display: flex;
  align-items: center;
}
.hkd {
  margin-top: 1px;
}
.hide_input {
  position: absolute;
  top: -500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/school/record/recruit_detail.vue